export const DEV_PARTNER_URL = "https://partner-dev.hellolunajoy.com";
export const PROD_PARTNER_URL = "https://partner.hellolunajoy.com";
export const LOCAL_PARTNER_URL = "http://localhost:3000";

export const DEV_BOOKING_URL = "https://booking-dev.hellolunajoy.com";
export const PROD_BOOKING_URL = "https://booking.hellolunajoy.com";
export const LOCAL_BOOKING_URL = "http://localhost:3001";

export const PARTNER_URL = window.location.hostname === 'partner.hellolunajoy.com' ? PROD_PARTNER_URL : DEV_PARTNER_URL;
export const BOOKING_URL = window.location.hostname === 'partner.hellolunajoy.com' ? PROD_BOOKING_URL : DEV_BOOKING_URL;

const formsApplicationUrl = process.env.REACT_APP_FORMS_LINK

export default formsApplicationUrl